import { useEffect } from "react";

/**
 * Custom hook to handle iOS Safari viewport issues
 * - Sets CSS custom property --vh for accurate viewport height
 * - Handles orientation changes properly
 * - Uses CSS-only approach for scroll prevention to avoid JS conflicts
 */
export const useMobileViewport = () => {
  useEffect(() => {
    // Function to set the viewport height
    const setViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    // Function to handle orientation change
    const handleOrientationChange = () => {
      // Small delay to ensure the viewport has updated
      setTimeout(setViewportHeight, 100);
    };

    // Initial setup
    setViewportHeight();

    // Add event listeners
    window.addEventListener("resize", setViewportHeight);
    window.addEventListener("orientationchange", handleOrientationChange);

    // Cleanup function
    return () => {
      window.removeEventListener("resize", setViewportHeight);
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);
};

export default useMobileViewport;
